module.exports = __webpack_public_path__ + "img/组 754@3x.b37b18b1.png";